import color from "context/MaterialUITheme/color";
import Typography from "@mui/material/Typography";
import CTrackerTimelineItem, {
  trackerStatusColor,
} from "components/CTimelineItem";
import API from "utils/API";
import { useState } from "react";
import { Box } from "@mui/material";
import useTracker from "components/CTracker/useTrackerContext";
import CoborrowerInvite from "components/CTracker/StepsDialogs/CoborrowerInvite";

const CreditVerification: React.FC = () => {
  const { loan, type } = useTracker();
  const isBorrower = type === "borrower";
  const [coborrowerInviteIsOpen, setCoborrowerInviteIsOpen] = useState(false);
  const step = isBorrower ? loan?.borrowerSteps : loan?.coborrowerSteps;
  const status = step?.creditVerification?.status ?? "pending";
  const message = step?.creditVerification?.message ?? "";
  const errorCode = step?.creditVerification.errorCode;

  return (
    <CTrackerTimelineItem
      status={status}
      title="Credit"
      tooltip="Our initial credit check only requires a soft pull. We currently use Experian to tell us your credit score and a summary of your credit profile"
      {...(isBorrower &&
        errorCode === "D001" &&
        !loan?.coborrowerInvite &&
        status !== "success" && {
          action: {
            message: "Add Co-Borrower",
            onClick: () => setCoborrowerInviteIsOpen(true),
          },
        })}
    >
      <Box display="flex">
        <Typography
          variant="h6"
          flex={1}
          color={color[trackerStatusColor[status] as keyof typeof color]}
        >
          {status === "analyzing" && "Analyzing"}
          {status === "failed" && message}
          {status === "success" && message}
        </Typography>
      </Box>
      <CoborrowerInvite
        open={coborrowerInviteIsOpen}
        onClose={async () => {
          setCoborrowerInviteIsOpen(false);
          await API.post({
            url: `/set-borrower-flags`,
            data: {
              creditVerificationCoborrowerOffered: true,
            },
          });
        }}
      />
    </CTrackerTimelineItem>
  );
};

export default CreditVerification;
